import React from 'react';
import styled, { keyframes } from 'styled-components';

import breakpoints from '../../util/breakpoints';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Circle = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(rgba(100, 131, 249, 0), rgba(100, 131, 249, 0.5));
  z-index: -1;
`;

const PlanetSVG = styled.img`
  position: fixed;
  top: 90%;
  width: 150%;
  margin-left: -25%;

  will-change: transform;
  animation: ${rotate} 320s linear infinite;
  border-radius: 75%;

  ${breakpoints.sm`
    top: 80%;
  `}
`;

const Planet = () => (
  <div>
    <Circle />
    <PlanetSVG src="/images/planet.svg" />
  </div>
);

export default Planet;



// WEBPACK FOOTER //
// ./src/components/ui/Planet.js